import { createContext, useContext } from 'react';
import type { ToastLevel } from '../components/ui/Toast';

interface ToastCtxValue { toast: (level: ToastLevel, message: string) => void }

export const ToastCtx = createContext<ToastCtxValue>({ toast: () => {} });

export function useToast() { return useContext(ToastCtx); }

/** Convenience helpers */
export function useToastHelpers() {
  const { toast } = useToast();
  return {
    info:    (msg: string) => toast('info', msg),
    success: (msg: string) => toast('success', msg),
    warn:    (msg: string) => toast('warn', msg),
    error:   (msg: string) => toast('error', msg),
  };
}
